import { useRouter } from 'expo-router'

import { Button } from '@/src/elements/button/default'
import { Header, type THeaderProps } from '@/src/elements/header'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

export const SettingsHeader = () => {
  const { routes } = useRoutes()
  const { navigate } = useRouter()
  const { t } = useTranslate()

  const { handleBackPress } = useBackHandlePress(routes['prayer-space']())

  const leftButtons: THeaderProps['leftButtons'] = [
    {
      type: 'icon',
      startIcon: ICON.ARROW_LEFT,
      onPress: handleBackPress,
    },
  ]

  const rightButtons: THeaderProps['rightButtons'] = [
    {
      type: 'button',
      component: () => (
        <Button
          testID={TEST_ID.SETTINGS.USER_EDIT_BUTTON}
          startIcon={ICON.PENCIL}
          isIconOnly
          colors="default"
          variant="light"
          contrast="low"
          onPress={() => navigate(routes.settingsAccount())}
        />
      ),
    },
  ]

  return (
    <Header
      title={t('user.profile.my-profile')}
      leftButtons={leftButtons}
      rightButtons={rightButtons}
      className="bg-primary-bg-medium gap-2 pr-4"
    />
  )
}
